
(function () {

    var homeSlideCount = $('#home-banners .swiper-slide.slide-large').length;

    // The "base" slider configuration.
    var homeBannerSwiperConfig = {
        centeredSlides: true,
        centerInsufficientSlides: true,
        enabled: false,
        watchOverflow: true,
    };

    // If there's more than 1 slide, we will extend/enable certain properties such as navigation and pagination.
    if (homeSlideCount > 1) {
        $.extend(homeBannerSwiperConfig, {
            enabled: true,
            loop: true,
            speed: 900,
            autoplay: {
                delay: 7000,
            },
            navigation: {
                nextEl: '#home-banners .swiper-arrow-next',
                prevEl: '#home-banners .swiper-arrow-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<li class="' + className + '"><button type="button" class="btnPage" data-page=' + (index + 1) + '>' + (index + 1) + '</button></li>';
                }
            },
            on: {
                slideChange: function () {
                    togglFeaturedSlides(this.realIndex);
                },
            },
        });
    }

    var homeBannerSwiper = new Swiper('#home-banners .swiper-container', homeBannerSwiperConfig);

    $('[data-feature-group]').each(function () {
        var productType = $(this).data('feature-group');

        var iFeatured = new Swiper("#featured-products-" + productType + " #swiper-container-" + productType, {
            loop: false,
            centeredSlides: false,
            centerInsufficientSlides: true,
            slidesPerView: 1,
            breakpoints: {
                1: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
                767: {
                    slidesPerView: 5,
                    centeredSlides: false,
                }
            },
            navigation: {
                nextEl: "#featured-products-" + productType + " .swiper-arrow-next",
                prevEl: "#featured-products-" + productType + " .swiper-arrow-prev"
            }
        });

    });
})();


function togglFeaturedSlides(currentSlideIndex) {
    var currentSlide = $(".swiper-slide[data-swiper-slide-index=" + currentSlideIndex + "]").first();

    if (currentSlide.length > 0) {

        var currentBannerproductType = currentSlide.data('banner-product-type');

        if (currentBannerproductType == undefined) {
            currentBannerproductType = currentSlide.data('banner-type');
        }

        var exists = false;
        // show correct slider dependant on product type - class 'hide' breaks the swiper slider
        $('[id*="divFeatured-"]').css({ visibility: 'hidden' });
        $('[id*="divFeatured-"]').css({ height: '0px' });

        $("#divFeatured-" + currentBannerproductType).css({ visibility: 'visible' });
        $("#divFeatured-" + currentBannerproductType).css({ height: 'inherit' });

        $('.hidFeaturedType').each(function () {
            var productType = $(this).val();

            var featuredCount = $("#featured-products-" + productType + " .featured-slide").length;

            //tidy up the page by removing blank space if no featured available for product type
            if (currentBannerproductType == productType && featuredCount == 0) {
                $("#sectionFeaturedProducts").removeClass('pt-1 pb-2');
                $("#sectionFeaturedProducts").removeClass('mb-3');
                $("#sectionFeaturedProducts-").css({ visibility: 'visible' });
            }
            else if (currentBannerproductType == productType && featuredCount > 0) {
                if (!$("#sectionFeaturedProducts").hasClass('pt-1 pb-2')) { $("#sectionFeaturedProducts").addClass('pt-1 pb-2') }
                if (!$("#sectionFeaturedProducts").hasClass('mb-3')) { $("#sectionFeaturedProducts").addClass('mb-3') }
                $("#sectionFeaturedProducts-").css({ visibility: 'visible' });
                exists = true;

                $(".featuredNavigation").css({ visibility: 'hidden' });
                var fNagigation = $("#featured-products-" + productType + " .featuredNavigation");
                if (window.screen.width >= 767) {
                    if (featuredCount <= 5) {
                        fNagigation.css({ visibility: 'hidden' });
                    }
                    else {
                        fNagigation.css({ visibility: 'visible' });
                    }
                }
                else {
                    if (featuredCount <= 2) {
                        fNagigation.css({ visibility: 'hidden' });
                    }
                    else {
                        fNagigation.css({ visibility: 'visible' });
                    }
                }

                if (featuredCount == 1) {
                    $('.featuredNameBorder').css({ borderLeft: 'unset' });
                }
                else {

                    var fCount = 0;
                    var fProducts = $("#featured-products-" + productType + " .featuredNameBorder");
                    fProducts.each(function () {
                        fCount++;
                        if (fCount == 1) {
                            $(this).css({ borderLeft: 'unset' });
                        }
                        else {
                            $(this).css({ borderLeft: '1px solid #c1c1c1' });
                        }
                    });
                }
            }
        });

        if (!exists) {
            $("#sectionFeaturedProducts").removeClass('pt-1 pb-2');
            $("#sectionFeaturedProducts").removeClass('mb-3');
        }
    }
}